import { isSocialBrowser } from "@faire/deprecated-retailer-visitor-shared/lib/user-agent/isSocialBrowser";
import {
  useAssignSetting,
  useSetting,
} from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FE_PREFETCH_SIGNUP_IFRAME_250328 } from "@faire/retailer-settings/FE_PREFETCH_SIGNUP_IFRAME_250328";

export const useSettingPrefetchSignUpIframe = () => {
  return useSetting(FE_PREFETCH_SIGNUP_IFRAME_250328);
};

const noop = () => {};

export const useAssignSettingPrefetchSignUpIframe = () => {
  const assign = useAssignSetting(FE_PREFETCH_SIGNUP_IFRAME_250328);
  if (isSocialBrowser()) {
    return noop;
  }
  return assign;
};
